<div *ngIf="initialized">
  <div class="contentblock">
    <h3>Mailing Settings</h3>

    <div class="form-group row">
      <label for="fromName" class="col-sm-2 col-form-label">From Name</label>
      <div class="col-sm-10">
        <input
          type="text"
          name="fromName"
          [(ngModel)]="mailingSettings.from.name"
        />
      </div>
    </div>

    <div class="form-group row">
      <label for="fromEmail" class="col-sm-2 col-form-label"
        >From Email Address</label
      >
      <div class="col-sm-10">
        <input
          type="email"
          name="fromEmail"
          [(ngModel)]="mailingSettings.from.email"
        />
      </div>
    </div>

    <div class="form-group row">
      <label for="save" class="col-sm-2 col-form-label"></label>
      <div class="col-sm-10">
        <button type="button" (click)="onSaveMailingSettings()">Save</button>
        <button
          type="button"
          class="delete-button"
          (click)="onDeleteMailingSettings()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</div>
